/* eslint-disable eqeqeq */
import React, { useEffect } from "react";
import { useSubheader } from "../../../_metronic/layout";
import {
  RestlessTable,
  RestlessButtonFormatter
} from "../../../_metronic/layout/components/Table";
import { useDispatch, useSelector } from "react-redux";
import { articlesHide, cleanError, contentHided, fetchReports, hideComments, markContentAsReviewed } from "../../../redux/actions/reports";
import RestlessDateFormatter from "../../../_metronic/layout/components/Table/RestlessDateFormatter";
import RestlessCategoryFormatter from "../../../_metronic/layout/components/Table/RestlessCategoryFormatter";
import RestlessReportContent from "../../../_metronic/layout/components/Table/RestlessReportContent";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { Route, Switch } from "react-router-dom";
import PostsDetailsDialog from "./RestlessPostsDialog/PostsDetailsDialog";
import { fetchImageToken } from "../../../redux/actions/imageAuth";
import RestlessModerationModal from "../../../_metronic/layout/components/modeationModal/RestlessModerationModal";
import {
  disabledUser,
  kickedUser,
  shadowbanUser,
} from "../../../redux/actions/users";
import { Alert } from "react-bootstrap";
import CommentsDetailsDialog from "./RestlessCommentsDialog/RestlessCommentsDialog";
import RestlessMarkReviewDialog from "./RestlessMarkReviewDialog/RestlessMarkReviewDialog";
import RestlessBooleanFormatter from "../../../_metronic/layout/components/Table/RestlessBooleanFormattear";

export default function RestlessReportsPage({ history }) {
  const suhbeader = useSubheader();
  suhbeader.setTitle("Reports");

  const dispatch = useDispatch();
  const { reportsList, listLoading, hideLoading, contentReportHided, error, commentHided, articlesHided } = useSelector(
    (state) => ({
      reportsList: state.reports.reportsList,
      articlesHided: state.reports.articlesHided,
      listLoading: state.reports.listLoading,
      hideLoading: state.reports.hideLoading,
      contentReportHided: state.reports.contentHided,
      commentHided: state.reports.commentHided,
      error: state.reports.error,
    })
  );

  useEffect(() => {
    dispatch(fetchImageToken());
    dispatch(fetchReports());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //Array of buttons, atributes = onClickFunction, text, icon
  const buttonsArr = [
    {
      onClickFunction: (row) => {
        if (row.type == 'Comment') {
          return commentsUIEvents.openCommentsDetailsDialog(row);
        }
        if (row.type == 'Post') {
          return postsUIEvents.openPostsDetailsDialog(row);
        }
        
      },
      icon: (
        <SVG title="Detail" src={toAbsoluteUrl("/media/svg/icons/Text/Bullet-list.svg")} />
      ),
      title: "Detail"
    },
    {
      onClickFunction: (row) => {
        if (row.type == 'Post') {
          return postsUIEvents.openModeratePostsDialog(row);
        }
        if (row.type == 'Comment') {
          return commentsUIEvents.openModerateCommentsDialog(row);
        }
        
      },
      disabled: true,
      icon: (
        <SVG title="Moderate" src={toAbsoluteUrl("/media/svg/icons/General/Settings-1.svg")} />
      ),
      title: "Moderate"
    },
    {
      onClickFunction: (row) => {
          return reviewContentUIEvents.openReviewContentDialog(row);
      },
      icon: (
        <SVG title="Monitor" src={toAbsoluteUrl("/media/svg/icons/Communication/Clipboard-check.svg")} />
      ),
      title: "Monitor"
    },
  ];

  //Functions to open the dialog for post
  const postsUIEvents = {
    openPostsDetailsDialog: (row) => {
      history.push({
        pathname: `/reports/${row.idReport}/details`,
        state: { row: row },
      });
    },
    openModeratePostsDialog: (row) => {
      history.push({
        pathname: `/reports/${row.idReport}/moderate`,
        state: { row: row },
      });
    },
  };

  //Functions to open the dialog for comments
  const commentsUIEvents = { 
    openCommentsDetailsDialog: (row) => {
      history.push({
        pathname: `/reports/${row.idReport}/details`,
        state: { row: row },
      });
    },
    openModerateCommentsDialog: (row) => {
      history.push({
        pathname: `/reports/${row.idReport}/moderate`,
        state: { row: row },
      });
    },
  };

  //Functions to open the dialog for Review Content
  const reviewContentUIEvents = {
    openReviewContentDialog: (row) => {
      history.push({
        pathname: `/reports/${row.idReport}/reviewcontent`,
        state: { row: row },
      });
    }
  };

  const columns = [
    {
      dataField: "restless_user.full_name",
      text: "Reporter",
      sort: true,
    },
    {
      dataField: "content.id",
      text: "ID",
      sort: true,
    },
    {
      dataField: "published_at",
      text: "Created",
      sort: true,
      formatter: RestlessDateFormatter,
    },
    {
      dataField: "type",
      text: "Type",
      sort: true,
      formatter: RestlessReportContent,
    },
    {
      dataField: "content.deleted",
      text: "Deleted",
      sort: true,
      formatter: RestlessBooleanFormatter,
    },
    {
      dataField: "reason",
      text: "Reason",
      sort: true,
      formatter: RestlessCategoryFormatter,
    },
    {
      dataField: "action1",
      formatter: RestlessButtonFormatter,
      formatExtraData: { buttonsArr },
    },
    
  ];

  const onSubmit = (values, row) => {
    if (values.moderateUser && values.userAction === "Disable_on_social") {
      dispatch(disabledUser({ id: row.restless_user.id, disableOnSocial: true }));
    }
    if (values.moderateUser && values.userAction === "Disable_on_self") {
      dispatch(disabledUser({ id: row.restless_user.id, disableOnSelf: true }));
    }

    if (values.moderateUser && values.userAction === "Kickout") {
      dispatch(kickedUser(row.restless_user.id));
    }
    if (values.moderateUser && values.userAction === "Shadowban") {
      dispatch(shadowbanUser(row.restless_user.id));
    }
 
    if (row.type == 'Post') {
      dispatch(contentHided(values,row.content.id));
    }
    if (row.type == 'Comment') {
      dispatch(hideComments(values,row.content.id));
    }
    if (row.type == 'Article') {
      dispatch(articlesHide(values,row.content.id));
    }

    history.push("/reports");
  };

  const renderContentModerationStatus = () => {
    return (
      <Alert variant="success" className="text-center" onClose={() => dispatch(cleanError())} dismissible>
        The content has been deleted succesfully
      </Alert>
    );
  };

  const renderContentModerationError = () => {
    return (
      <Alert variant="danger" className="text-center" dismissible onClose={() => dispatch(cleanError())} >
        An error has occurred
      </Alert>
    );
  };

  const markContentAsReview = (content, reviewNotes) => {
    dispatch(markContentAsReviewed(content, reviewNotes))
    history.push("/reports");
  };

  return (
    <>
      {listLoading || hideLoading ? (
        <div className="d-flex justify-content-center align-content-center">
          <span className="mx-3 spinner spinner-primary"></span>
        </div>
      ) : (
        <>
          {!error && (contentReportHided || commentHided || articlesHided) && renderContentModerationStatus()}
          {error && (!contentReportHided && !commentHided && !articlesHided) && renderContentModerationError()}
          <Switch>
            <Route path="/reports/:id/details">
            {({ history, match }) => {
                if(history.location.state?.row.type == 'Post') {
                  return <PostsDetailsDialog
                  show={match != null}
                  id={match && match.params.id}
                  row={history.location.state?.row}
                  onHide={() => {
                    history.push("/reports");
                  }}
                /> 
                }
                if(history.location.state?.row.type == 'Comment') {
                  return <CommentsDetailsDialog
                  show={match != null}
                  id={match && match.params.id}
                  row={history.location.state?.row}
                  onHide={() => {
                    history.push("/reports");
                  }}
                /> 
                }
             }}
            </Route>
            <Route path="/reports/:id/moderate">
              {({ history, match }) => (
                <RestlessModerationModal
                  show={match != null}
                  id={match && match.params.id}
                  row={history.location.state?.row}
                  onSubmit={onSubmit}
                  onHide={() => {
                    history.push("/reports");
                  }}
                  entityType={(history.location.state?.row.type)}
                />
              )}
            </Route>
            <Route path="/reports/:id/reviewcontent">
              {({ history, match }) => (
                  <RestlessMarkReviewDialog
                  show={match != null}
                  id={match && match.params.id}
                  row={history.location.state?.row}
                  markContentAsReview={markContentAsReview}
                  onHide={() => {
                    history.push("/reports");
                  }}
                />
              )}
            </Route>
          </Switch>
          <RestlessTable data={reportsList} columns={columns} withPagination />
        </>
      )}
    </>
  );
}
